import accountInfoImport from './accountInfo'

export const setAccountInfo = accountInfoImport
